module.exports = __webpack_public_path__ + "img/fat bar 2.ffda16ec.png";